import { cx } from './select/classNames'
import type { SelectOption } from './select/types'

/**
 * Renders the shared primary/secondary option label used in select triggers and
 * listbox rows.
 */
export const renderSelectOptionLabel = (
  option: SelectOption,
  selected: boolean,
  emphasizePrimaryLabel: boolean,
) => (
  <span className="block truncate">
    <span
      className={cx(
        emphasizePrimaryLabel ? 'font-semibold' : 'font-medium',
        selected ? 'text-(--color-text-primary,#0f172a)' : 'text-(--color-text-primary,#1f2937)',
      )}
    >
      {option.label}
    </span>
    {option.secondaryLabel ? (
      <span className="ml-1.5 text-(--color-text-muted,#64748b)">· {option.secondaryLabel}</span>
    ) : null}
  </span>
)
